function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Observable } from '../../utils/observables/observable';
import { PerfKey, perfLogger, PerfTag } from '../../utils/perf';
import { throwUnsupportedValue } from '../../utils/ts';
import { VideoPlatform } from '../../video-platforms/integration-provider';
import { OvpDataAdapters } from '../../video-platforms/ovp/ovp-data-adapters';
import { playoutDataErrorAdapter as skyStorePlayoutDataErrorAdapter, playerErrorAdapter as skyStorePlayerErrorAdapter, playoutResponseAdapter as skyStoreResponseAdapter } from '../../video-platforms/skystore/skystore-data-adapters';
import { playoutDataErrorAdapter as smilPlayoutDataErrorAdapter, playerErrorAdapter as smilPlayerErrorAdapter, playoutResponseAdapter as smilResponseAdapter } from '../../video-platforms/smil/smil-data-adapters';
import { PlaybackType } from '../player/playout-data';
import { InternalConfigProvider } from '../../config/internal-config-provider';
var PLAYOUT_REQUEST_ERROR_MESSAGE = {
    'Request timeout': 'Request timeout on playout fetch'
};
export var VideoPlatformIntegration = /*#__PURE__*/ function() {
    "use strict";
    function VideoPlatformIntegration(vpip, cvi, config, hdcpManager) {
        var _this = this;
        _class_call_check(this, VideoPlatformIntegration);
        var _this1 = this;
        _define_property(this, "vpip", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "playoutDataRequestedObservable", void 0);
        _define_property(this, "playoutResponseAdapter", void 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- https://gspcloud.atlassian.net/browse/VPTJS-12907
        _define_property(this, "playoutDataErrorAdapter", void 0);
        _define_property(this, "playerErrorAdapter", void 0);
        _define_property(this, "prefetchTokenExchangeErrorAdapter", void 0);
        _define_property(this, "heartbeatRequestOptionsAdapter", void 0);
        _define_property(this, "thirdPartiesRequestOptionsAdapter", void 0);
        _define_property(this, "ovpDataAdapters", void 0);
        _define_property(this, "sendHeartbeat", void 0);
        _define_property(this, "stopHeartbeat", void 0);
        _define_property(this, "decorateLicenseRequest", void 0);
        _define_property(this, "exchangePrefetchToken", void 0);
        _define_property(this, "onPlayoutDataRequested", void 0);
        _define_property(this, "adaptPlayerError", void 0);
        _define_property(this, "removePlayoutDataRequestedListener", void 0);
        this.vpip = vpip;
        this.config = config;
        this.playoutDataRequestedObservable = new Observable();
        this.sendHeartbeat = function(url, sessionItem, streamPosition) {
            var options = _this.heartbeatRequestOptionsAdapter(sessionItem);
            return _this.vpip.sendHeartbeat(url, streamPosition, options);
        };
        this.stopHeartbeat = function(url, sessionItem, streamPosition) {
            var options = _this.heartbeatRequestOptionsAdapter(sessionItem);
            return _this.vpip.stopHeartbeat(url, streamPosition, options);
        };
        this.decorateLicenseRequest = function(request) {
            var _this_vpip_decorateLicenseRequest, _this_vpip;
            var _this_vpip_decorateLicenseRequest1;
            return (_this_vpip_decorateLicenseRequest1 = (_this_vpip_decorateLicenseRequest = (_this_vpip = _this.vpip).decorateLicenseRequest) === null || _this_vpip_decorateLicenseRequest === void 0 ? void 0 : _this_vpip_decorateLicenseRequest.call(_this_vpip, request)) !== null && _this_vpip_decorateLicenseRequest1 !== void 0 ? _this_vpip_decorateLicenseRequest1 : request;
        };
        this.exchangePrefetchToken = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(sessionItem, playoutData) {
                var options, _this_prefetchTokenExchangeErrorAdapter, errorAdapter, streamSourceType, resp, e, _errorAdapter;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            options = _this1.ovpDataAdapters.exchangePrefetchTokenRequestOptionsAdapter(sessionItem, playoutData);
                            errorAdapter = (_this_prefetchTokenExchangeErrorAdapter = _this1.prefetchTokenExchangeErrorAdapter) !== null && _this_prefetchTokenExchangeErrorAdapter !== void 0 ? _this_prefetchTokenExchangeErrorAdapter : _this1.playoutDataErrorAdapter;
                            switch(sessionItem.type){
                                case PlaybackType.VOD:
                                case PlaybackType.Clip:
                                case PlaybackType.Preview:
                                case PlaybackType.FER:
                                    streamSourceType = 'VOD';
                                    break;
                                case PlaybackType.Live:
                                    streamSourceType = 'LINEAR';
                                    break;
                                case PlaybackType.SingleLiveEvent:
                                    streamSourceType = 'EVENT';
                                    break;
                                default:
                                    throw errorAdapter('Unknown session item type');
                            }
                            if (!playoutData.prefetch) {
                                throw errorAdapter('No prefetch data provided');
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this1.vpip.exchangePrefetchToken(playoutData.prefetch.prePlayoutId, playoutData.prefetch.metadataToken, streamSourceType, options)
                            ];
                        case 2:
                            resp = _state.sent();
                            return [
                                2,
                                resp
                            ];
                        case 3:
                            e = _state.sent();
                            throw (_errorAdapter = errorAdapter(e)) !== null && _errorAdapter !== void 0 ? _errorAdapter : e;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(sessionItem, playoutData) {
                return _ref.apply(this, arguments);
            };
        }();
        this.onPlayoutDataRequested = function(callback, callbackOwner) {
            _this.playoutDataRequestedObservable.registerObserver(callback, callbackOwner);
        };
        this.adaptPlayerError = function(error) {
            return _this.playerErrorAdapter(error);
        };
        this.removePlayoutDataRequestedListener = function(callbackOwner) {
            _this.playoutDataRequestedObservable.unregisterObservers(callbackOwner);
        };
        switch(vpip.type){
            case VideoPlatform.OVP:
            case VideoPlatform.ONE_APP:
                this.ovpDataAdapters = new OvpDataAdapters(cvi, hdcpManager);
                this.playoutResponseAdapter = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any -- https://gspcloud.atlassian.net/browse/VPTJS-12907
                responseData, sessionItem, vpiSessionResponseOptions) {
                    return _this.ovpDataAdapters.playoutResponseAdapter(responseData, sessionItem, vpiSessionResponseOptions);
                };
                this.playoutDataErrorAdapter = function(e) {
                    return _this.ovpDataAdapters.playoutDataErrorAdapter(e);
                };
                this.playerErrorAdapter = function(e) {
                    return _this.ovpDataAdapters.playerErrorAdapter(e);
                };
                this.prefetchTokenExchangeErrorAdapter = function(e) {
                    return _this.ovpDataAdapters.prefetchTokenExchangeErrorAdapter(e);
                };
                this.heartbeatRequestOptionsAdapter = function(sessionItem) {
                    return _this.ovpDataAdapters.heartbeatRequestOptionsAdapter(sessionItem);
                };
                this.thirdPartiesRequestOptionsAdapter = function(config) {
                    return _this.ovpDataAdapters.thirdPartiesRequestOptionsAdapter(config);
                };
                break;
            case VideoPlatform.SKYSTORE:
                // @ts-ignore
                this.playoutResponseAdapter = skyStoreResponseAdapter;
                this.playoutDataErrorAdapter = skyStorePlayoutDataErrorAdapter;
                this.playerErrorAdapter = skyStorePlayerErrorAdapter;
                break;
            case VideoPlatform.SMIL:
                // @ts-ignore
                this.playoutResponseAdapter = smilResponseAdapter;
                this.playoutDataErrorAdapter = smilPlayoutDataErrorAdapter;
                this.playerErrorAdapter = smilPlayerErrorAdapter;
                break;
            default:
                throw new Error("Unsupported Video Platform: ".concat(vpip.type));
        }
    }
    _create_class(VideoPlatformIntegration, [
        {
            key: "getPlayoutData",
            value: function getPlayoutData(sessionItem, vpiSessionRequestOptions, vpiSessionResponseOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    var playoutDataPromise;
                    return _ts_generator(this, function(_state) {
                        playoutDataPromise = _this.handleGetPlayoutData(sessionItem, vpiSessionRequestOptions, vpiSessionResponseOptions);
                        _this.playoutDataRequestedObservable.notifyObservers(playoutDataPromise);
                        return [
                            2,
                            playoutDataPromise
                        ];
                    });
                })();
            }
        },
        {
            key: "getUMVToken",
            value: function getUMVToken() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_vpip_getToken, _this_vpip;
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            (_this_vpip_getToken = (_this_vpip = _this.vpip).getToken) === null || _this_vpip_getToken === void 0 ? void 0 : _this_vpip_getToken.call(_this_vpip)
                        ];
                    });
                })();
            }
        },
        {
            key: "handleGetPlayoutData",
            value: function handleGetPlayoutData(sessionItem, vpiSessionRequestOptions, vpiSessionResponseOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    var playbackType, _this_ovpDataAdapters, requestOptions, // eslint-disable-next-line @typescript-eslint/no-explicit-any -- https://gspcloud.atlassian.net/browse/VPTJS-12907
                    responseData, vpipGetPlayout, _this_thirdPartiesRequestOptionsAdapter, _this1, addonsConfig, thirdParties, adaptedResponse, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                playbackType = sessionItem.type;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                perfLogger.measure(PerfKey.root, PerfTag.ovpRequestAdaptStart);
                                return [
                                    4,
                                    (_this_ovpDataAdapters = _this.ovpDataAdapters) === null || _this_ovpDataAdapters === void 0 ? void 0 : _this_ovpDataAdapters.playoutRequestAdapter(_this.config, sessionItem, vpiSessionRequestOptions)
                                ];
                            case 2:
                                requestOptions = _state.sent();
                                perfLogger.measure(PerfKey.root, PerfTag.ovpRequestAdaptEnd);
                                vpipGetPlayout = null;
                                switch(playbackType){
                                    case PlaybackType.Live:
                                        vpipGetPlayout = _this.vpip.getLivePlayoutData;
                                        break;
                                    case PlaybackType.Clip:
                                    case PlaybackType.FER:
                                    case PlaybackType.VOD:
                                        vpipGetPlayout = _this.vpip.getVodPlayoutData;
                                        break;
                                    case PlaybackType.SingleLiveEvent:
                                        vpipGetPlayout = _this.vpip.getEventPlayoutData;
                                        break;
                                    case PlaybackType.Preview:
                                        vpipGetPlayout = _this.vpip.getPreviewPlayoutData;
                                        break;
                                    default:
                                        break;
                                }
                                if (!vpipGetPlayout) return [
                                    3,
                                    4
                                ];
                                vpipGetPlayout = vpipGetPlayout.bind(_this.vpip);
                                addonsConfig = InternalConfigProvider.getForPlaybackType(_this.config, sessionItem.type).addons;
                                thirdParties = (_this_thirdPartiesRequestOptionsAdapter = (_this1 = _this).thirdPartiesRequestOptionsAdapter) === null || _this_thirdPartiesRequestOptionsAdapter === void 0 ? void 0 : _this_thirdPartiesRequestOptionsAdapter.call(_this1, addonsConfig);
                                if (requestOptions) {
                                    requestOptions.thirdParties = thirdParties || [];
                                } else {
                                    requestOptions = {
                                        thirdParties: thirdParties || []
                                    };
                                }
                                perfLogger.measure(PerfKey.root, PerfTag.ovpPlayoutReqStart);
                                return [
                                    4,
                                    vpipGetPlayout(sessionItem.key, requestOptions)
                                ];
                            case 3:
                                responseData = _state.sent();
                                perfLogger.measure(PerfKey.root, PerfTag.ovpPlayoutReqEnd);
                                _state.label = 4;
                            case 4:
                                if (responseData) {
                                    perfLogger.measure(PerfKey.root, PerfTag.ovpResponseAdaptStart);
                                    adaptedResponse = _this.playoutResponseAdapter(responseData, sessionItem, vpiSessionResponseOptions);
                                    perfLogger.measure(PerfKey.root, PerfTag.ovpResponseAdaptEnd);
                                    return [
                                        2,
                                        adaptedResponse
                                    ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                _this.alterPlayoutError(e);
                                throw _this.playoutDataErrorAdapter(e);
                            case 6:
                                throwUnsupportedValue(playbackType, Object.values(PlaybackType));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "alterPlayoutError",
            value: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- https://gspcloud.atlassian.net/browse/VPTJS-12907
            function alterPlayoutError(e) {
                if (e.message && PLAYOUT_REQUEST_ERROR_MESSAGE[e.message]) {
                    e.message = PLAYOUT_REQUEST_ERROR_MESSAGE[e.message];
                }
            }
        }
    ]);
    return VideoPlatformIntegration;
}();

//# sourceMappingURL=video-platform-integration.js.map